<template>
  <div id="app">
    <js-top></js-top>
    <js-menu></js-menu>
    <transition name="el-fade-in-linear">
      <router-view />
    </transition>
    <js-footer/>
  </div>
</template>

<script>
import jsTop from '@/packages/JsTop.vue'
import jsMenu from '@/packages/JsMenu.vue'
import jsFooter from '@/packages/JsFooter.vue'
export default {
  name: 'app',
  components: {
    jsTop,
    jsMenu,
    jsFooter
  }
}
</script>

<style>

</style>
